import React from "react";
import { ShieldCheck, Target, Microscope, HeartPulse } from "lucide-react";

const About = () => {
  const values = [
    {
      icon: <Target className="text-[#D4AF37]" size={20} />,
      title: "Our Mission",
      desc: "Revolutionizing sustainable farming through superior genetics and data protocols."
    },
    {
      icon: <Microscope className="text-[#2D5A27]" size={20} />,
      title: "Scientific Approach",
      desc: "Tracked lineages ensuring predictable growth and elite health outcomes."
    },
    {
      icon: <ShieldCheck className="text-[#D4AF37]" size={20} />,
      title: "Quality Assurance",
      desc: "Zero-tolerance for parasites, providing only elite breeding stock."
    },
    {
      icon: <HeartPulse className="text-[#2D5A27]" size={20} />,
      title: "Animal Welfare",
      desc: "Stall-fed systems ensuring peak nutrition and stress-free environments."
    }
  ];

  return (
    <div className="bg-[#FDFCF8] min-h-screen pt-10 pb-12 overflow-x-hidden">
      
      <section className="pt-0 pb-10 border-b border-gray-100">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <span className="text-[9px] font-black uppercase tracking-[0.5em] text-[#D4AF37] block mb-2">
            ESTABLISHED FACILITY
          </span>
          <h1 className="text-4xl md:text-5xl font-black text-[#4B3621] tracking-tighter mb-4 leading-tight">
            Guru's Sheep & <br />
            <span className="text-[#2D5A27]">Goat Farms.</span>
          </h1>
          <p className="text-sm md:text-base text-gray-500 font-medium leading-relaxed max-w-2xl mx-auto">
            Located at the intersection of traditional wisdom and modern biological science, 
            we are a livestock research and breeding powerhouse.
          </p>
        </div>
      </section>

      <section className="py-10">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {values.map((item, index) => (
              <div key={index} className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 hover:shadow-lg transition-all duration-500">
                <div className="mb-4 bg-[#FDFCF8] w-10 h-10 rounded-xl flex items-center justify-center">
                  {item.icon}
                </div>
                <h3 className="text-[#4B3621] font-black text-sm mb-2 uppercase tracking-tight">
                  {item.title}
                </h3>
                <p className="text-gray-500 text-[11px] leading-relaxed">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-12 bg-[#2D5A27] rounded-3xl max-w-6xl mx-auto mx-6 text-white relative overflow-hidden shadow-2xl">
        <div className="max-w-3xl mx-auto px-6 text-center relative z-10">
          <h2 className="text-xl md:text-2xl font-black tracking-tighter mb-4 italic">
            "We don't just sell livestock; we provide the foundation for your farm's future profitability."
          </h2>
          <div className="w-12 h-1 bg-[#D4AF37] mx-auto"></div>
          <p className="mt-4 text-white/60 font-black uppercase tracking-widest text-[8px]">
             The Guru's Research Philosophy
          </p>
        </div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-[8rem] font-black text-white/[0.03] select-none pointer-events-none">
          GURU
        </div>
      </section>
    </div>
  );
};

export default About;